import { IconButton, Modal,ContextualMenu,mergeStyleSets, PrimaryButton, DefaultButton, Spinner, SpinnerSize, registerIcons } from "@fluentui/react";
import React, { useEffect, useState,useContext } from "react";
import $ from "jquery";
import "./modalStyles.css";
import { ErrorIcon } from "@fluentui/react-icons-mdl2";
import CancelPathologyIcon from "../SVGComponents/CancelPathologyIcon";
import { CUSTOM_STYLES } from "../../constants/Constants";
import ModalHeader from "../Modal/ModalHeader";
import ModalFooter from "../Modal/ModalFooter";
import ModalMain from "../Modal/ModalMain";
import { t } from "i18next";
import themeContext from "../../context/theme/ThemeContext";

const AlertSuccessModal = (props) => {
  const { getThemeColor} = useContext(themeContext);
  useEffect(()=>{
    registerIcons({
      icons: {
        cancelCustomIcon:<CancelPathologyIcon/>
      },
    });
  },[])

    let DefaultButtonList = [
      {
        title: t("button.ok"),
        onclick: props.hideModal,
      },
    ];

    const modalDetails = {
      header: (
        <ModalHeader
          updatedModal={true}
          heading={props.heading}
          handleCancel={props.hideModal}
        />
      ),
      body: <div className="global-modal-body" style={{color:getThemeColor("primary-color")}}>{props.description}</div>,
      footer: <ModalFooter PrimaryButtonList={[]} DefaultButtonList={DefaultButtonList} />,
      width: "500px",
    };
  
   

    return (
      <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />
      //   <Modal
      //   isOpen={props.isModalOpen}
      //   containerClassName={contentStyles.container}
      //   dragOptions= {{
      //     moveMenuItemText: "Move",
      //     closeMenuItemText: "Close",
      //     menu: ContextualMenu,
      //     dragHandleSelector: "#header-id",
      //     keepInBounds: true,
      //   }}
      //   styles={contentStyles}
      // >
      //    <>
      //   {/* <div id="header-id"  className={contentStyles.header}>
        
      //     <h2 id="header-title" className={contentStyles.heading}>
      //       {props.heading}
      //     </h2>
      //     <IconButton
      //       styles={iconButtonStyles}
      //       iconProps={cancelIcon}
      //       ariaLabel="Close popup modal"
      //       onClick={props.hideModal}
      //     />
      //   </div> */}
      //   <div id="header-id" className='modal-header-container-updated'>
      //       <div className="modal-header-heading-updated">{props.heading}</div>
      //       <div className="modal-header-crossicon">
      //       <IconButton
      //        styles={iconButtonStyles}
      //       iconProps = {{iconName: 'Cancel'}}
      //       ariaLabel="Close popup modal"
      //       onClick={props.hideModal}
      //       // style={{border:"none",outline:"none",color:"#FFFFFF",border:"1px solid white"}}
      //       className='modal-header-crossicon-button'
      //       />
      //       </div>
      //   </div>
      //   <div className={contentStyles.body}>
      //     {/* <div style={{display:'flex', color: '#C3C4CD',marginBottom: '8px'}}>
      //       Description :
      //     </div> */}
      //     {props.description}
      //   </div>
      //   <div className={contentStyles.footer}>
      //       <div style={{display:'flex'}}>
      //           <DefaultButton text="OK" onClick={props.hideModal} />
      //       </div>
      //   </div></>
      // </Modal>
    )
}

export default AlertSuccessModal;